//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.PmiFilter.js";
let d=[[],[[["n_types"],"GetPmiTypes",{R_:{types:""}},0,0],[["types"],"SetPmiTypes",{},1,0]],[]];
SPLM.Annotations.PmiFilterByType = class extends SPLM.Annotations.PmiFilter{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.PmiFilterByType";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.PmiFilterByType.Type = Object.freeze({
    "Dimension" : "Dimension", "FeatureControlFrame" : "FeatureControlFrame", "Datum" : "Datum", "DatumTarget" : "DatumTarget", "Note" : "Note", "GeneralNote" : "GeneralNote", "SpecificNote" : "SpecificNote", "CoordinateNote" : "CoordinateNote", "BalloonNote" : "BalloonNote", "CustomSymbol" : "CustomSymbol", "Centerline" : "Centerline", "LineWeld" : "LineWeld", "Crosshatch" : "Crosshatch", "Material" : "Material", "SurfaceFinish" : "SurfaceFinish", "Locator" : "Locator", "EnterpriseIdentifier" : "EnterpriseIdentifier", "Process" : "Process", "PartIdentifier" : "PartIdentifier", "Emarking" : "Emarking", "Url" : "Url", "UserDefined" : "UserDefined", "Geometry" : "Geometry", "CuttingPlaneSymbol" : "CuttingPlaneSymbol", "Table" : "Table"});

export default SPLM;